import Ajax from '../ajax'

export default {
  firstCategory: () => Ajax('get', 'front/category/listFirst'),
  category: () => Ajax('get', 'front/category/list')
}
